import React from 'react';

import { Grid, Segment, Button, Modal } from 'semantic-ui-react';

import { Wallet, Symbols, Position, UserConfig, Statistics } from './index';

class Trade extends React.Component {
	constructor (props) {
		super(props);

		this.state = {
			showedUserConfig: false,
			symbol: null,
			screen: 'trade'
		};
	}

	openModal = (key) => () => {
		this.setState({
			[key]: true
		});
	};

	closeModal = (key) => () => {
		this.setState({
			[key]: false
		});
	};

	changeSymbol = (symbol) => {
		this.setState({
			symbol
		});
	}

	setScreen = (screen) => {
		this.setState({
			screen
		});
	}

	render () {
		const {
			showedUserConfig,
			symbol,
			screen
		} = this.state;

		return (
			<Segment>
				<Grid centered divided="vertically">
					<Grid.Row columns={1}>
						<Grid.Column>
							<Wallet/>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row columns={1}>
						<Grid.Column>
							<Symbols symbol={symbol} changeSymbol={this.changeSymbol}/>
						</Grid.Column>
					</Grid.Row>

					{(screen === 'trade') ? (!!symbol ? <Grid.Row columns={1}><Grid.Column>
							<Position screen={screen} symbol={symbol}/>
						</Grid.Column></Grid.Row>: <></>) : <></>}
					{(screen === 'users') ? <Grid.Row columns={1}>
						 <Grid.Column>
							<Statistics screen={screen} symbol={symbol}/>
						</Grid.Column>
					</Grid.Row>  : <></>}
					<Grid.Row columns={2}>
						<Grid.Column>
							<div className="ui buttons">
								<Button className="ui green button" onClick={() => this.setScreen('trade')}>Торговля</Button>
								<div className="|"></div>
								<Button className="ui blue button" onClick={() => this.setScreen('users')}>Пользователи</Button>
							</div>
						</Grid.Column>
						<Grid.Column>
							<Modal
								centered
								open={showedUserConfig}
								size="small"
								onOpen={this.openModal('showedUserConfig')}
								trigger={<Button
									compact
									size="small"
									floated="right"
									icon={'cogs'}
								/>}
							>
								<UserConfig closeModal={this.closeModal('showedUserConfig')}/>
							</Modal>
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</Segment>
		);
	}
}

export default Trade;
